export function sanitizeId(id) {
    if (id) {
        return id.replace(/_.*$/, '').replace('-', '');
    }
}

export function getExperimentCookieKey(experimentId) {
    return `DEV_AB_${experimentId}`;
}
